import React, { useState, useEffect } from "react";
import Card from "../../components/Card";
import Tabs from "../../components/Tabs";
import { useLocation } from "react-router-dom";
import { useTitle } from "../../hooks/useTitle";
import CourseCalendar from "./CourseCalendar";
import ScheduleCalendar from "./ScheduleCalendar";
import "./Calendar.css";
import InnerHeader from "../../components/InnerHeader";

const Calendar = () => {
  const tabs = [
    { label: "Course Calendar", value: "course-calendar" },
    { label: "Schedule Calendar", value: "schedule-calendar" },
  ];
  const [selectedTab, setSelectedTab] = useState("course-calendar");
  const [nextActiveTab, setNextActiveTab] = useState("1");
  useTitle("Calendar - Access Your Account - Flapone Aviation");

  const location = useLocation();
  const handleTabChange = (value) => {
    setSelectedTab(value);
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get("tab");
    if (tabParam && tabs.some((tab) => tab.value === tabParam)) {
      setSelectedTab(tabParam);
    }
    // eslint-disable-next-line
  }, [location.search]);

  return (
    <>
      <InnerHeader
        heading="My Calendar"
        txtSubHeading="View and manage your training schedule. Stay updated with upcoming
              sessions and important dates."
        showButton={false}
      />
      <Card className="account-conatiner bg1 mt16 p20 pb48">
        {selectedTab === "course-calendar" && <CourseCalendar />}
      </Card>
    </>
  );
};

export default Calendar;
